var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { view as bbqView } from '@bilibili-bbq/razor';
import databus from './../common/databus';
import { getScript, getJsonp, getList, setChannelKey } from './../common/utils';
export default function clientContent(share) {
    var _a = databus.browser, isBbqApp = _a.isBbqApp, isWechat = _a.isWechat, isQQ = _a.isQQ;
    clientInit();
    function clientInit() {
        if (isBbqApp) {
            bbqView.setShare({
                showBtn: 1,
                config: {
                    title: share.title,
                    content: share.desc,
                    pic: share.pics,
                    url: share.link
                }
            });
            return;
        }
        if (isQQ) {
            qqReady();
        }
        else if (isWechat) {
            weChatReady(function (signature) {
                setWeChatContent(signature);
            });
        }
    }
    function qqReady() {
        var _a = share.qq, title = _a.title, link = _a.link, desc = _a.desc, pics = _a.pics;
        var qqShare = {
            title: title,
            link: link,
            summary: desc,
            pic: pics
        };
        if (!window.setShareInfo) {
            getScript('https://qzonestyle.gtimg.cn/qzone/qzact/common/share/share.js', function () {
                window.setShareInfo && window.setShareInfo(qqShare);
            });
        }
        else {
            window.setShareInfo(qqShare);
        }
    }
    function weChatReady(callback) {
        var _a = databus.wechatConfig, timestamp = _a.timestamp, nonceStr = _a.nonceStr;
        getJsonp('https://app.bilibili.com/x/display/wechat/sign', {
            timestamp: timestamp,
            url: window.location.href,
            nonce: nonceStr,
            jsonp: 'jsonp'
        }, function (res) {
            console.log('wechat sign: ', res);
            if (res.code === 0) {
                getScript('https://res.wx.qq.com/open/js/jweixin-1.2.0.js', function () {
                    callback && callback(res.data);
                });
                return;
            }
            console.warn('getting wechat sign in share-h5 error: ', res);
            throw new Error(res);
        });
    }
    function setWeChatContent(signature) {
        var _a = databus.wechatConfig, wxconfigappid = _a.wxconfigappid, nonceStr = _a.nonceStr, timestamp = _a.timestamp, jsApiList = _a.jsApiList;
        if (window.wx) {
            window.wx.config({
                beta: true,
                debug: false,
                appId: wxconfigappid,
                nonceStr: nonceStr,
                timestamp: timestamp,
                signature: signature,
                jsApiList: jsApiList
            });
            window.wx.ready(function () {
                setWeChatDetails();
            });
        }
    }
    function setWeChatDetails() {
        var shareChannelQueue = share.shareChannelQueue, weixin = share.weixin, weixin_moment = share.weixin_moment, success = share.success, cancel = share.cancel;
        var wxShare = { title: weixin.title, desc: weixin.desc, link: weixin.link, imgUrl: weixin.pics };
        var timeShare = { title: weixin_moment.title, desc: weixin_moment.desc, link: weixin_moment.link, imgUrl: weixin_moment.pics };
        getList('wxApi', shareChannelQueue).forEach(function (item) {
            var channelKey = item.name;
            var key = item.wxApi || '';
            var wechatShareConfig = __assign(__assign({}, (key === 'onMenuShareTimeline' ? timeShare : wxShare)), { link: decodeURIComponent(setChannelKey(key === 'onMenuShareTimeline' ? timeShare.link : wxShare.link, channelKey)), success: function () {
                    success({ platform: channelKey });
                },
                cancel: function () {
                    cancel({ platform: channelKey });
                } });
            window.wx[key](wechatShareConfig);
        });
    }
}
